import { render, staticRenderFns } from "./importOrExport.vue?vue&type=template&id=01011c21&scoped=true"
import script from "./importOrExport.vue?vue&type=script&lang=js"
export * from "./importOrExport.vue?vue&type=script&lang=js"
import style0 from "./importOrExport.vue?vue&type=style&index=0&id=01011c21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01011c21",
  null
  
)

export default component.exports